// src/api/tesoreriaApi.js
//
// Cliente de todos los endpoints /api/pos/admin-plataforma/ de tesorería.

import { api, API_BASE_URL, tokenStorage, manejarNoAutorizado } from './apiClient';

const BASE = '/api/pos/admin-plataforma';

export const configuracion = {
  listar: (categoria) => api.get(`${BASE}/configuracion`,
    { query: categoria ? { categoria } : {} }),
  actualizar: (clave, valor, activo = true) =>
    api.put(`${BASE}/configuracion/${encodeURIComponent(clave)}`, { valor, activo }),
  crear: (dto) => api.post(`${BASE}/configuracion`, dto),
  historico: (clave) => api.get(`${BASE}/configuracion/historico/${encodeURIComponent(clave)}`),
};

export const facturas = {
  listar: (filtros = {}) => api.get(`${BASE}/facturas-saas`, { query: filtros }),
  generarPeriodo: (anio, mes) =>
    api.post(`${BASE}/facturas-saas/generar-periodo`, { anio, mes }),
  marcarPagada: (id, dto) =>
    api.post(`${BASE}/facturas-saas/${id}/pagar`, dto),
  anular: (id, motivo) =>
    api.post(`${BASE}/facturas-saas/${id}/anular`, { motivo }),
  // D-24
  reenviar: (id) => api.post(`${BASE}/facturas-saas/${id}/reenviar`, {}),
  extenderPlazo: (id, dias) => api.post(`${BASE}/facturas-saas/${id}/extender-plazo`, { dias }),
  /** Descarga el PDF de la cuenta de cobro (con el JWT) y lo abre en otra pestaña. */
  abrirPdf: async (id) => {
    const res = await fetch(`${API_BASE_URL}${BASE}/facturas-saas/${id}/pdf`, {
      headers: { Authorization: `Bearer ${tokenStorage.get()}` },
    });
    if (res.status === 401) { manejarNoAutorizado(); throw new Error('Sesión expirada.'); }
    if (!res.ok) throw new Error('No se pudo descargar la cuenta de cobro.');
    const blob = await res.blob();
    const url = URL.createObjectURL(blob);
    window.open(url, '_blank', 'noopener');
    setTimeout(() => URL.revokeObjectURL(url), 60000);
  },
};

// D-24 — Suscripciones: cortes, estado de cobro y mora de cada negocio.
export const suscripciones = {
  listar: (filtros = {}) => api.get(`${BASE}/suscripciones`, { query: filtros }),
  resumen: (anio, mes) => api.get(`${BASE}/suscripciones/resumen`, { query: { anio, mes } }),
  procesarCiclo: () => api.post(`${BASE}/suscripciones/procesar-ciclo`, {}),
};

export const liquidacionesGuias = {
  calcular: (desde, hasta, guiaId) =>
    api.post(`${BASE}/liquidaciones-guias/calcular`,
      { periodoDesde: desde, periodoHasta: hasta, guiaId }),
  generar: (desde, hasta, guiaId) =>
    api.post(`${BASE}/liquidaciones-guias/generar`,
      { periodoDesde: desde, periodoHasta: hasta, guiaId }),
  listar: (filtros = {}) => api.get(`${BASE}/liquidaciones-guias`, { query: filtros }),
  detalle: (id) => api.get(`${BASE}/liquidaciones-guias/${id}`),
  marcarPagada: (id, dto) => api.post(`${BASE}/liquidaciones-guias/${id}/pagar`, dto),
  anular: (id, motivo) => api.post(`${BASE}/liquidaciones-guias/${id}/anular`, { motivo }),
};

export const inversionistas = {
  listar: () => api.get(`${BASE}/inversionistas`),
  crear: (dto) => api.post(`${BASE}/inversionistas`, dto),
  actualizar: (id, dto) => api.put(`${BASE}/inversionistas/${id}`, dto),
};

export const resultados = {
  calcular: (desde, hasta) =>
    api.get(`${BASE}/resultados`, { query: { desde, hasta } }),
  generarCierre: (desde, hasta, notas) =>
    api.post(`${BASE}/resultados/cierres`,
      { periodoDesde: desde, periodoHasta: hasta, notas }),
  listarCierres: () => api.get(`${BASE}/resultados/cierres`),
  listarEgresos: (desde, hasta) =>
    api.get(`${BASE}/resultados/egresos`, { query: { desde, hasta } }),
  crearEgreso: (dto) => api.post(`${BASE}/resultados/egresos`, dto),
  eliminarEgreso: (id) => api.delete(`${BASE}/resultados/egresos/${id}`),
};
